import React from 'react';
import { Form, Card } from 'react-bootstrap';

const FilterCard = ({ filter, isActive, onToggle, onValueChange, currentValue }) => {
  const renderFilterInput = () => {
    switch (filter.filter_type) {
      case 'range':
        const rangeValue = currentValue || { min: filter.min || 0, max: filter.max || 1000 };
        return (
          <div className="d-flex align-items-center gap-2">
            <Form.Control
              type="number"
              placeholder="Min"
              size="sm"
              value={rangeValue.min || ''}
              onChange={(e) => onValueChange(filter.id, { ...rangeValue, min: parseInt(e.target.value) || 0 })}
              disabled={!isActive}
            />
            <span className="text-muted">to</span>
            <Form.Control
              type="number"
              placeholder="Max"
              size="sm"
              value={rangeValue.max || ''}
              onChange={(e) => onValueChange(filter.id, { ...rangeValue, max: parseInt(e.target.value) || filter.max })}
              disabled={!isActive}
            />
          </div>
        );

      case 'select':
        return (
            <Form.Select
            size="sm"
            value={currentValue || ''}
            onChange={(e) => onValueChange(filter.id, e.target.value)}
            disabled={!isActive}
            >
            <option value="">Select {filter.name}</option>
            {filter.options ? (
                // Use options from API if available
                filter.options.map(option => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
                ))
            ) : (
                // Fallback for fields without predefined options
                <option value="text_input">Enter custom value</option>
            )}
            </Form.Select>
        );

      case 'date':
        return (
          <Form.Control
            type="date"
            size="sm"
            value={currentValue || ''}
            onChange={(e) => onValueChange(filter.id, e.target.value)}
            disabled={!isActive}
          />
        );

      case 'text':
      default:
        return (
          <Form.Control
            type="text"
            placeholder={`Enter ${filter.name}`}
            size="sm"
            value={currentValue || ''}
            onChange={(e) => onValueChange(filter.id, e.target.value)}
            disabled={!isActive}
          />
        );
    }
  };

  return (
    <Card className={`filter-card ${isActive ? 'border-primary' : ''}`} style={{ marginBottom: '1rem' }}>
      <Card.Body className="p-3">
        <div className="d-flex justify-content-between align-items-start mb-2">
          <div className="flex-grow-1">
            <h6 className="mb-1 text-dark">{filter.name}</h6>
            <small className="text-muted">{filter.column} ({filter.data_type})</small>
          </div>
          <Form.Check
            type="switch"
            id={`filter-${filter.id}`}
            checked={isActive}
            onChange={(e) => onToggle(filter.id, e.target.checked)}
            className="ms-2"
          />
        </div>
        
        <div className="filter-controls">
          {renderFilterInput()}
        </div>
      </Card.Body>
    </Card>
  );
};

export default FilterCard;